<template>
  <div class="tags">
    <span v-for="i in tags" :key="i">#{{i}}</span>
  </div>
</template>
<script>
export default {
  props: {
    tags: {
      type: Array
    }
  }
};
</script>
<style lang="scss" scoped>
.tags {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: calc(100% - 25rem);
  padding: 1rem 0;
  @media only screen and (max-width: 768px) {
    width: auto;
  }
  span {
    color: #262262;
    margin-right: 5px;
  }
  &.white {
    span {
      color: #fff;
    }
  }
}
</style>